import styled from '@emotion/styled';
import { Box, CardProps } from '@mui/material';
import { Column } from '../../styles';
import { Breakpoint, isExpanded } from '../../types';
import { shouldForwardProps } from '../../utils';

interface Props extends CardProps {
    sharpCorners: boolean;
    breakpoint: Breakpoint;
}

const CollapsibleTileContainer = styled(Column, shouldForwardProps)<Props>`
    border-radius: ${({ sharpCorners }) => (sharpCorners ? '0' : '12px')};
    padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
    background-color: transparent;
    overflow: visible;
`;

const CollapsibleTileContent = styled(Box, shouldForwardProps)<{ breakpoint: Breakpoint }>`
    display: flex;
    flex-direction: ${({ breakpoint }) => (isExpanded(breakpoint) ? 'row' : 'column')};
    gap: ${({ theme }) => theme.spacing(3)};
    padding-top: ${({ theme }) => theme.spacing(2)};
    padding-bottom: ${({ theme }) => theme.spacing(3)};
`;

export { CollapsibleTileContainer, CollapsibleTileContent };
